import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { ShopinfoModel } from '../../system/shopinfo/model/shopinfo.model';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { UserInfoModel } from 'src/app/common/models/user-info.model';
import { AppConstants } from 'src/app/common/app.constants';
import { ExpenseTypeSummaryReportService } from './expense-type-summary-report.service';
import { DatePipe } from '@angular/common';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-expense-type-summary-report',
  standalone: false,
  templateUrl: './expense-type-summary-report.component.html',
  styleUrl: './expense-type-summary-report.component.scss'
})
export class ExpenseTypeSummaryReportComponent {

  title: string = "Expense Type Summary";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  currentMonth: number;
  // years: number[];
  selectedYear: any;
  selectedFilter: any;
  weeks: any[] = [];
  shopListData: any = [];
  areaListData: any = [];
  shopFilter: string = '';
  regionFilter: string = '';
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  curFinYear!: string; // Add this to your component properties  
  isExpandedShop = false;
  isExpandedRegion = false;
  resetButtonEnabledForShop: boolean = false;
  resetButtonEnabledForRegion: boolean = false;
  showSelectedShopOnly: boolean = false;
  showSelectedRegionOnly: boolean = false;

  months: any[] = [
    { value: 0, name: 'Jan' },
    { value: 1, name: 'Feb' },
    { value: 2, name: 'Mar' },
    { value: 3, name: 'Apr' },
    { value: 4, name: 'May' },
    { value: 5, name: 'Jun' },
    { value: 6, name: 'Jul' },
    { value: 7, name: 'Aug' },
    { value: 8, name: 'Sep' },
    { value: 9, name: 'Oct' },
    { value: 10, name: 'Nov' },
    { value: 11, name: 'Dec' }
  ];
  permission: any;

  weekRequiredValidator: ValidatorFn = (group: AbstractControl): null => {
    const filter = group.get('filter')?.value;
    const weekFromCtrl = group.get('weekFrom');
    const weekToCtrl = group.get('weekTo');
    if (filter === 'week') {
      if (!weekFromCtrl?.value) {
        weekFromCtrl?.setErrors({ ...weekFromCtrl.errors, required: true });
      } else if (weekFromCtrl.hasError('required')) {
        const errors = { ...weekFromCtrl.errors };
        delete errors['required'];
        weekFromCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
      if (!weekToCtrl?.value) {
        weekToCtrl?.setErrors({ ...weekToCtrl.errors, required: true });
      } else if (weekToCtrl.hasError('required')) {
        const errors = { ...weekToCtrl.errors };
        delete errors['required'];
        weekToCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    } else {
      // Remove required error if filter is not week
      if (weekFromCtrl?.hasError('required')) {
        const errors = { ...weekFromCtrl.errors };
        delete errors['required'];
        weekFromCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
      if (weekToCtrl?.hasError('required')) {
        const errors = { ...weekToCtrl.errors };
        delete errors['required'];
        weekToCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
    return null;
  };

  weekRangeValidator: ValidatorFn = (group: AbstractControl): null => {
    const weekFromCtrl = group.get('weekFrom');
    const weekToCtrl = group.get('weekTo');
    const filter = group.get('filter')?.value;
    if (!weekFromCtrl || !weekToCtrl) return null;
    const weekFrom = Number(weekFromCtrl.value);
    const weekTo = Number(weekToCtrl.value);
    if (filter === 'week' && weekFromCtrl.value && weekToCtrl.value && weekTo < weekFrom) {
      weekToCtrl.setErrors({
        ...weekToCtrl.errors,
        invalidWeekRange: true
      });
    } else {
      if (weekToCtrl.hasError('invalidWeekRange')) {
        const errors = { ...weekToCtrl.errors };
        delete errors['invalidWeekRange'];
        weekToCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
    return null;
  };

  monthRangeValidator: ValidatorFn = (group: AbstractControl): null => {
    const filter = group.get('filter')?.value;
    const monthFromCtrl = group.get('monthFrom');
    const monthToCtrl = group.get('monthTo');
    if (!monthFromCtrl || !monthToCtrl) return null;
    const monthFrom = Number(monthFromCtrl.value);
    const monthTo = Number(monthToCtrl.value);
    if (filter === 'month' && monthFromCtrl.value != null && monthToCtrl.value != null && monthTo < monthFrom) {
      monthToCtrl.setErrors({
        ...monthToCtrl.errors,
        invalidMonthRange: true
      });
    } else {
      if (monthToCtrl.hasError('invalidMonthRange')) {
        const errors = { ...monthToCtrl.errors };
        delete errors['invalidMonthRange'];
        monthToCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
    return null;
  };

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private expenseTypeSummaryReportService: ExpenseTypeSummaryReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private permissionService: PermissionService,
    public dialog: MatDialog, private datePipe: DatePipe) {

    const currentMonth = new Date().getMonth(); // 0 = Jan, 11 = Dec


    this.editForm = this.builder.group({
      filter: new FormControl('week'),
      year: this.builder.control(null, Validators.required),
      weekFrom: this.builder.control([]),
      weekTo: this.builder.control([]),
      monthFrom: this.builder.control([0]),
      monthTo: this.builder.control([currentMonth]),
      shopFilter: this.builder.control(''),
      regionFilter: this.builder.control(''),

      shopFilterAll: [''],
      shopFilterSelected: [''],
      regionFilterAll: [''],
      regionFilterSelected: [''],

    }, { validators: [this.weekRequiredValidator, this.weekRangeValidator, this.monthRangeValidator] });

    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth(); // 0 = Jan, 11 = Dec
    this.permission = permissionService.getPagePermission("expense-type-summary");
    console.log(this.permission);
  }
  getNextWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      startDate.setHours(0, 0, 0, 0);
      return startDate > today;
    });
  }


  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  ngOnInit(): void {
    this.loadData();
    this.areaList();
    this.shopList();

    this.editForm.get('filter')?.valueChanges.subscribe(filter => {
      // Reset other fields when type changes
      this.editForm.patchValue({
        weekFrom: '',
        weekTo: '',
        monthFrom: '',
        monthTo: ''
      });
    });
  }

  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };

  }

  toggleContent(divData: string): void {
    if (divData == "shop") {
      this.isExpandedShop = !this.isExpandedShop;
    }
    if (divData == "region") {
      this.isExpandedRegion = !this.isExpandedRegion;
    }
  }

  saveToSessionStorage(selectionData: any): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    if (selectionData == "shop") {
      const selectedShopIds = this.shopListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.code);

      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      if (selectedShopIds.length > 0) {
        this.resetButtonEnabledForShop = true;
      } else {
        this.resetButtonEnabledForShop = false;
      }

    }

    if (selectionData == "region") {
      const selectedRegionIds = this.areaListData
        .filter((region: any) => region.selected)
        .map((region: any) => region.item.code);

      // If no shops are selected, we treat it as "ALL" (empty array means all shops)
      const regionIds = selectedRegionIds.length > 0 ? selectedRegionIds : [];
      if (selectedRegionIds.length > 0) {
        this.resetButtonEnabledForRegion = true;
      } else {
        this.resetButtonEnabledForRegion = false;
      }


    }

  }


  areaList(): void {

    this.expenseTypeSummaryReportService.getAreaList().subscribe(
      (response: any) => {
        this.areaListData = [];
        var index = 0;
        response.data.areas.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.areaListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }
  get filteredShopListData() {
    let filteredList = this.shopListData;
    if (this.showSelectedShopOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('shopFilterAll')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllShop() {
    const allSelected = this.shopListData.every((item: any) => item.selected);
    this.shopListData.forEach((item: any) => (item.selected = !allSelected));
    this.updateResetButtonStateForShop();
  }

  getSelectAllIconShop(): string {
    const allSelected = this.shopListData.every((item: any) => item.selected);
    const someSelected = this.shopListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get selectedShopSourcesCount(): number {
    return this.shopListData?.filter((item: any) => item.selected)?.length || 0;
  }

  get filteredRegionListData() {
    let filteredList = this.areaListData;
    if (this.showSelectedRegionOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('regionFilterAll')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllRegion() {
    const allSelected = this.areaListData.every((item: any) => item.selected);
    this.areaListData.forEach((item: any) => (item.selected = !allSelected));
    this.updateResetButtonStateForRegion();
  }

  getSelectAllIconRegion(): string {
    const allSelected = this.areaListData.every((item: any) => item.selected);
    const someSelected = this.areaListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get selectedRegionSourcesCount(): number {
    return this.areaListData?.filter((item: any) => item.selected)?.length || 0;
  }

  loadData(): void {

    let requestData = this.buildRequestData();
    this.expenseTypeSummaryReportService.getWeekNoList(requestData).subscribe(response => {
      console.log('API Response:', response);

      if (response.status === 'SUCCESS') {
        // Filter financial years to show only those that have actually started
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        this.financialYears = response.data.finYears
          .filter((fy: any) => {
            if (fy.weeks && fy.weeks.length > 0) {
              // Sort weeks to get the first week by week number
              const sortedWeeks = fy.weeks.slice().sort((a: any, b: any) => a.week_no - b.week_no);
              const firstWeek = sortedWeeks[0];
              const firstWeekStartDate = new Date(firstWeek.start_date);
              firstWeekStartDate.setHours(0, 0, 0, 0);
              // Only show financial years whose first week has started
              return firstWeekStartDate <= today;
            }
            // If no weeks data, fall back to year comparison
            return fy.year <= today.getFullYear();
          })
          .sort((a: any, b: any) => b.year - a.year);

        this.years = this.financialYears.map(fy => fy.year);

        // Only set the default value if the form control is empty
        if (!this.editForm.get('year')?.value) {
          this.curFinYear = response.data.curFinYear;
          if (this.curFinYear) {
            const yearValue = parseInt(this.curFinYear);
            this.editForm.get('year')?.setValue(yearValue, { emitEvent: false });

            // Set weeks for the current financial year
            const currentFinYear = this.financialYears.find(fy => fy.year === yearValue);
            if (currentFinYear) {
              // Only include weeks whose start_date <= today, and sort desc
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const filteredWeeks = currentFinYear.weeks
                .filter((week: any) => {
                  const weekStartDate = new Date(week.start_date);
                  weekStartDate.setHours(0, 0, 0, 0);
                  return weekStartDate <= today;
                })
                .map((week: any) => ({
                  ...week,
                  displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
                }))
                .sort((a: any, b: any) => b.week_no - a.week_no);

              this.weeks = filteredWeeks;

              // Set the current week as default
              const currentWeek = this.getCurrentWeek(this.weeks);
              const nextWeek = this.getNextWeek(this.weeks);
              if (currentWeek) {
                this.editForm.get('weekFrom')?.setValue(currentWeek.week_no);
                this.editForm.get('weekTo')?.setValue(nextWeek ? nextWeek.week_no : currentWeek.week_no);

              } else if (this.weeks.length > 0) {
                // Fallback to first week if current week not found
                this.editForm.get('weekFrom')?.setValue(this.weeks[0].week_no);
                this.editForm.get('weekTo')?.setValue(this.weeks[1]?.week_no ?? this.weeks[0].week_no);
              }
            }
          }
        }

        console.log('Financial Years Data:', this.financialYears);
      } else {
        console.error('API Error:', response.message);
      }
    });
  }

  onFilterChange(): void {
    this.selectedFilter = this.editForm.get('filter')?.value;
    if (this.selectedFilter == 'week') {
      this.selectedYear = this.editForm.get('year')?.value;
      const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

      if (selectedFinYear) {
        // Only include weeks whose start_date <= today, and sort desc
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const filteredWeeks = selectedFinYear.weeks
          .filter((week: any) => {
            const weekStartDate = new Date(week.start_date);
            weekStartDate.setHours(0, 0, 0, 0);
            return weekStartDate <= today;
          })
          .map((week: any) => ({
            ...week,
            displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
          }))
          .sort((a: any, b: any) => b.week_no - a.week_no);

        this.weeks = filteredWeeks;

        const currentWeek = this.getCurrentWeek(this.weeks);
        const nextWeek = this.getNextWeek(this.weeks);
        if (currentWeek) {
          this.editForm.get('weekFrom')?.setValue(currentWeek.week_no);
          this.editForm.get('weekTo')?.setValue(nextWeek ? nextWeek.week_no : currentWeek.week_no);

        } else if (this.weeks.length > 0) {
          // Fallback to first week if current week not found
          this.editForm.get('weekFrom')?.setValue(this.weeks[0].week_no);
          this.editForm.get('weekTo')?.setValue(this.weeks[1]?.week_no ?? this.weeks[0].week_no);
        }

      } else {
        this.weeks = [];
        this.editForm.get('weekFrom')?.setValue(null);
        this.editForm.get('weekTo')?.setValue(null);
      }

    } else {
      this.editForm.get('monthFrom')?.setValue(this.months[0].value);
      this.editForm.get('monthTo')?.setValue(this.months[11].value);
    }
  }

  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Only include weeks whose start_date <= today, and sort desc
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const filteredWeeks = selectedFinYear.weeks
        .filter((week: any) => {
          const weekStartDate = new Date(week.start_date);
          weekStartDate.setHours(0, 0, 0, 0);
          return weekStartDate <= today;
        })
        .map((week: any) => ({
          ...week,
          displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
        }))
        .sort((a: any, b: any) => b.week_no - a.week_no);

      this.weeks = filteredWeeks;

      const currentWeek = this.getCurrentWeek(this.weeks);
      const nextWeek = this.getNextWeek(this.weeks);
      if (currentWeek) {
        this.editForm.get('weekFrom')?.setValue(currentWeek.week_no);
        this.editForm.get('weekTo')?.setValue(nextWeek ? nextWeek.week_no : currentWeek.week_no);

      } else if (this.weeks.length > 0) {
        // Fallback to first week if current week not found
        this.editForm.get('weekFrom')?.setValue(this.weeks[0].week_no);
        this.editForm.get('weekTo')?.setValue(this.weeks[1]?.week_no ?? this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('weekFrom')?.setValue(null);
      this.editForm.get('weekTo')?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }

  shopList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "shop.name", order: "ASC" }] } }

    this.ShopinfoService.getShopList(requestData).subscribe(
      (response: any) => {
        this.shopListData = [];
        var index = 0;
        response.data.shops.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.shopListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }


  updateResetButtonStateForShop(): void {
    this.resetButtonEnabledForShop = this.shopListData?.some((shop: any) => shop.selected);
  }
  updateResetButtonStateForRegion(): void {
    this.resetButtonEnabledForRegion = this.areaListData?.some((region: any) => region.selected);
  }

  onListSelectionChange(selectionData: any): void {
    if (selectionData === 'shop') {
      this.updateResetButtonStateForShop();
    }
    if (selectionData === 'region') {
      this.updateResetButtonStateForRegion();
    }
    this.saveToSessionStorage(selectionData);
  }
  exportClicked(): void {
    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      let snackBarData: SnackBarData = {
        message: 'Please fill all required fields.',
        title: 'Validation Error',
        type: 'error'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }

    // Get selected shop IDs (if none are selected, treat it as "ALL")
    this.IsDownloading = true;

    const selectedShopIds = this.shopListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    const selectedAreaIds = this.areaListData
      .filter((area: any) => area.selected)
      .map((area: any) => area.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];
    const regionFrom = selectedAreaIds.length > 0 ? selectedAreaIds : [];

    // Create the data object
    const filterVal = this.editForm.get('filter')?.value;

    const reportData = {
      filter: this.editForm.get('filter')?.value,
      year: this.editForm.get('year')?.value,
      dateFrom: filterVal === 'week'
        ? this.editForm.get('weekFrom')?.value
        : this.editForm.get('monthFrom')?.value,
      dateTo: filterVal === 'week'
        ? this.editForm.get('weekTo')?.value
        : this.editForm.get('monthTo')?.value,
      shopId: shopIds,
      regionFrom: regionFrom,
      isExport: 1
    };
    console.log(reportData);

    if (reportData) {
      this.expenseTypeSummaryReportService.exportExpenseReport(reportData).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);

              // Check for no data found status
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found for the selected criteria.',
                  title: 'No Data Found!',
                  type: 'warn'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check for other error statuses
              if (json.status === 'ERROR' || json.status === 'FAILED') {
                let snackBarData: SnackBarData = {
                  message: json.message || 'An error occurred while generating the report.',
                  title: 'Error!',
                  type: 'error'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // If we reach here with a JSON response, show warning
              let snackBarData: SnackBarData = {
                message: 'Unexpected response format from server.',
                title: 'Warning!',
                type: 'warn'
              };
              this.IsDownloading = false;
              this.snackBarService.openSnackBar(snackBarData);

            } catch (e) {
              // If JSON parsing fails, it's likely a binary file (Excel)
              // Check if the response is empty or very small
              if (response.size === 0) {
                let snackBarData: SnackBarData = {
                  message: 'No data available for export.',
                  title: 'No Data Found!',
                  type: 'warn'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check if response is too small to be a valid file
              if (response.size < 100) {
                let snackBarData: SnackBarData = {
                  message: 'No data found for the selected criteria.',
                  title: 'No Data Found!',
                  type: 'warn'
                };
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Valid binary file - proceed with download
              const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'expense-type-summary-report.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;

              // Show success message
              let snackBarData: SnackBarData = {
                message: 'Report downloaded successfully.',
                title: 'Success!',
                type: 'success'
              };
              this.snackBarService.openSnackBar(snackBarData);
            }
          };

          reader.readAsText(response);
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.IsDownloading = false;

          let snackBarData: SnackBarData = {
            message: 'An error occurred while fetching the report. Please try again.',
            title: 'Error!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }


}
